import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationRepository } from 'src/app/core/data/repository';

import { RoutesConstants } from '../common';
import { concatMap, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthPagesGuard implements CanActivate {
  // constructor
  constructor(private authenticationRepository: AuthenticationRepository, private router: Router) {}
  // --------------

  // canActivate =>
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.authenticationRepository.isLoggedIn()) {
      this.router.navigate(['/' + RoutesConstants.DASHBOARD_PAGE_URL]);
      return false;
    } else {
      return this.authenticationRepository.logout().pipe(
        concatMap((res) => {
          return of(true);
        })
      );
    }
  }
}
